import {
  bsiInternetBankApi,
  type BsiIbLastThirtyItem,
  type BsiStatementRegistrationSummary,
} from '@/lib/banks/bsi/api';

export async function loadBsiStatementRegistrations(
  accountNumber: string,
  items: BsiIbLastThirtyItem[],
): Promise<BsiStatementRegistrationSummary[]> {
  if (!accountNumber.trim() || items.length === 0) return [];
  try {
    const res = await bsiInternetBankApi.lookupStatementRegistrations({
      account_number: accountNumber.trim(),
      items,
    });
    return res.data.items || [];
  } catch {
    return items.map(() => ({
      fingerprint: '',
      registered: false,
    }));
  }
}

export function updateRegistrationAtIndex(
  registrations: BsiStatementRegistrationSummary[],
  index: number,
  registration: BsiStatementRegistrationSummary,
): BsiStatementRegistrationSummary[] {
  const next = [...registrations];
  next[index] = registration;
  return next;
}
